import * as ko from "knockout";
import template from './ContentHeader.html';
import { Country } from "../localization";

class ContentHeader {

  languages: ko.ObservableArray<Country> = ko.observableArray();
  selectLanguageText: ko.Observable<string> = ko.observable<string>("");
  logoUri: ko.Observable<string> = ko.observable<string>("");
  logoAlt: ko.Observable<string> = ko.observable<string>("Logo");
  title: ko.Observable<string> = ko.observable<string>("");
  subTitle: ko.Observable<string> = ko.observable<string>("");
  headerText: ko.Observable<string> = ko.observable<string>("");
  link1Text: ko.Observable<string> = ko.observable<string>("");
  link1Uri: ko.Observable<string> = ko.observable<string>("");
  link2Text: ko.Observable<string> = ko.observable<string>("");
  link2Uri: ko.Observable<string> = ko.observable<string>("");
  link3Text: ko.Observable<string> = ko.observable<string>("");
  link3Uri: ko.Observable<string> = ko.observable<string>("");

  // Computed properties - initialized in constructor
  selectedLanguage: ko.PureComputed<string>;

  constructor() {
    global.Logonme.log(`ContentHeader: constructor, initial language = ${global.Logonme.SelectedLanguage()}`);

    // Initialize computed properties
    this.selectedLanguage = ko.pureComputed<string>(() => global.Logonme.SelectedLanguage());

    this.updateStrings(this.selectedLanguage());
    this.selectedLanguage.subscribe((lang: string) => {
      this.updateStrings(lang);
    });

    const localizations = global.Logonme.LocalizationManager.getLocalizations();
    for (let i = 0; i < localizations.length; i++) {
      this.languages.push(localizations[i]);
    }
  }

  private updateStrings(lang: string): void {
    this.selectLanguageText(global.Logonme.LocalizationManager.getText('header-select-language', lang));
    const logoFile = global.Logonme.LocalizationManager.getText('header-logo-uri', lang, '');
    this.logoUri(logoFile ? `${global.Logonme.Configuration.baseUrl}/ls/${global.Logonme.Configuration.tenant}/asset/${logoFile}` : '');
    this.logoAlt(global.Logonme.LocalizationManager.getText('header-logo-alt', lang, 'Logo'));
    this.title(global.Logonme.LocalizationManager.getText('content-header-title', lang, ''));
    this.subTitle(global.Logonme.LocalizationManager.getText('content-header-subtitle', lang, ''));
    this.headerText(global.Logonme.LocalizationManager.getText('content-header-text', lang, ''));
    this.link1Uri(global.Logonme.LocalizationManager.getText('content-header-link1-src', lang, ''));
    this.link1Text(global.Logonme.LocalizationManager.getText('content-header-link1-text', lang, ''));
    this.link2Uri(global.Logonme.LocalizationManager.getText('content-header-link2-src', lang, ''));
    this.link2Text(global.Logonme.LocalizationManager.getText('content-header-link2-text', lang, ''));
    this.link3Uri(global.Logonme.LocalizationManager.getText('content-header-link3-src', lang, ''));
    this.link3Text(global.Logonme.LocalizationManager.getText('content-header-link3-text', lang, ''));
  }

  isSelectedLanguage(val: Country): boolean {
    const isSelected = this.selectedLanguage() === val.langCode;
    global.Logonme.log(`ContentHeader.isSelectedLanguage: ${val.langCode} === ${this.selectedLanguage()} ? ${isSelected}`);
    return isSelected;
  }

  async selectLanguage(val: Country): Promise<void> {
    global.Logonme.log(`ContentHeader.selectLanguage: changing from ${global.Logonme.SelectedLanguage()} to ${val.langCode}`);
    global.Logonme.SelectedLanguage(val.langCode);
  }
}

export default { viewModel: ContentHeader, template: template };
